import { Equipment } from "@/models/equipment.model";
import { Settings } from "@/models/settings.model";
import { ElementaryZone } from "@/models/site.model";
import store from "@/store";
import { Component, Prop, Vue } from "vue-property-decorator";
import { BCollapse } from "bootstrap-vue";

@Component
export default class BalanceSheetElementaryZoneDisplayComponent extends Vue {
  @Prop() elementaryZone!: ElementaryZone;
  @Prop() settings!: Settings;
  @Prop() id!: number;

  tooltipHelpEacmSection = this.$sanitize(
    this.$t("help.balanceSheetPage.airEntryByZoneEacmSection").toString()
  );
  tooltipHelpEarSection = this.$sanitize(
    this.$t("help.balanceSheetPage.airEntryByZoneEarSection").toString()
  );
  isPresent = false;

  get collapseId(): string {
    return `collapse_${this.id}`;
  }

  visible = false;
  memoVisible = false;

  startCollapsingForPrinting(): void {
    this.memoVisible = this.visible;
    this.setVisible(true);
  }

  stopCollapsingForPrinting(): void {
    this.setVisible(this.memoVisible);
  }

  setVisible(_visible: boolean): void {
    this.visible = _visible; // le boutton
    (<BCollapse>this.$refs.collapseDiv).show = _visible; // le tableau
  }

  get eacmEquipment(): Equipment {
    return store.state.equipmentsModule.eacmEquipment;
  }
  /*Evolution majeure de EACM */
  get optionalEacmEquipment(): Equipment {
    return store.state.equipmentsModule.optionalEacmEquipment;
  }

  get earEquipment(): Equipment {
    return store.state.equipmentsModule.earEquipment;
  }
  
  /*Evolution majeure de EACM */
  get verifSiteEacmOptional():boolean {
    let isPresent = false
    const listSitesOptional = store.state.equipmentsModule.optionalEacmsites;
    
    if(listSitesOptional && listSitesOptional.length >0) {
      const findSite=listSitesOptional.findIndex((site:ElementaryZone) => site.name === this.elementaryZone.name);
      if(findSite !== (-1)) {
        isPresent=true;
      }
    }
    return isPresent;
  }

  // round Value with the number of precision we define
  roundValue(value: string, precision: number): string {
    this.verifSiteEacmOptional
    return (Math.round(parseFloat(value) * 10) / 10).toFixed(precision);
  }
}
